const moduleName = 'children';

const SELECT_CHILD = `${moduleName}/SELECT_CHILD`;

export default {
  SELECT_CHILD,
};
